import { useId } from '@uifabric/react-hooks';
import { IButtonProps, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import { composeSendButton } from 'owa-locstrings/lib/strings/composesendbutton.locstring.json';
import { getCommands } from 'owa-mail-hotkeys/lib/utils/MailModuleHotKeys';
import { convertHotkeyToReadableText } from 'owa-readable-hotkeys/lib/utils/convertHotkeyToReadableText';
import { getFirstHotkey } from 'owa-readable-hotkeys/lib/utils/getFirstHotkey';
import { hasKeybindForCurrentMode } from 'owa-readable-hotkeys/lib/utils/hasKeybindForCurrentMode';
import * as React from 'react';
import {
    composePostButton,
    composeScheduleSendButton,
    composeScheduleSendSplitButtonAriaDescribeBy,
} from '../strings.locstring.json';

const styles = require('./ComposeBottom.scss');
const classNames = require('classnames/bind').bind(styles);

export interface ComposeSendButtonProps {
    showSendAsIcon: boolean;
    isPublicFolderComposeViewState: boolean;
    onSend: () => void;
    onScheduledSendClicked: () => void;
    isDisabled: boolean;
    isScheduledSendEnabled: boolean;
}

export default function ComposeSendButton(props: ComposeSendButtonProps) {
    const sendClassName = classNames(styles.sendButton, {
        iconButton: props.showSendAsIcon,
    });

    const sendLabel = props.isPublicFolderComposeViewState
        ? loc(composePostButton)
        : loc(composeSendButton);

    const sendHotkey = getFirstHotkey(getCommands().sendMail);

    const sendTitle = hasKeybindForCurrentMode(sendHotkey)
        ? `${sendLabel} (${convertHotkeyToReadableText(sendHotkey)})`
        : sendLabel;

    const commonProps: IButtonProps = {
        className: sendClassName,
        onClick: props.onSend,
        ariaLabel: sendLabel,
        disabled: props.isDisabled,
        title: sendTitle,
    };

    const ariaDescriptionId = useId('sendSplitButton');

    const buttonProps =
        props.isScheduledSendEnabled && props.onScheduledSendClicked
            ? {
                  ...commonProps,
                  split: true,
                  menuProps: {
                      items: [
                          {
                              key: 'RegularSendMessage',
                              text: sendLabel,
                              onClick: props.onSend,
                          },
                          {
                              key: 'ScheduleSendMessage',
                              text: loc(composeScheduleSendButton),
                              onClick: props.onScheduledSendClicked,
                          },
                      ],
                  },
              }
            : commonProps;

    return (
        <>
            {props.isScheduledSendEnabled && (
                <span className={styles.splitButtonAriaDescription} id={ariaDescriptionId}>
                    {loc(composeScheduleSendSplitButtonAriaDescribeBy)}
                </span>
            )}
            <PrimaryButton
                {...buttonProps}
                aria-describedby={props.isScheduledSendEnabled ? ariaDescriptionId : undefined}>
                {props.showSendAsIcon ? <Icon iconName={ControlIcons.Send} /> : sendLabel}
            </PrimaryButton>
        </>
    );
}
